import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import { DesktopNav } from './DesktopNav';
import Logo from '../Images/Logo.png';
import '../Styles/LayoutStyle.css';
import { Footer } from './Footer';

export class Layout extends Component {
  displayName = Layout.name

  render() {
    return (
        <Grid fluid>
            <Row style={{ textAlign: "center" }}>
                <img className="home-logo" src={Logo} alt="Calloways Health & Fitness" />
            </Row>
            <Row>
                <DesktopNav />
            </Row>
            <Row style={{minHeight:"400px"}}> 
                {this.props.children}
            </Row>
            <Row>
                <Footer/>
            </Row>
        </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js